import React, { useState } from 'react';
import { Box, Container, Toolbar } from '@mui/material';
import Header from '../components/Header/Header';
import Sidebar, { drawerWidth } from '../components/Sidebar/Sidebar';
import Footer from '../components/Footer';
import { WelcomeOverlayRoot } from '../components/WelcomeOverlay';
import AmbientBackground from '../components/AmbientBackground';

/**
 * Shared dashboard chrome: ambient background, sidebar, navbar, scrollable main, footer.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children - page content
 * @param {string} props.brandPath - navigate target when clicking the StackTrack brand
 * @param {Array<{ id: string, title: string, initiallyExpanded?: boolean, items: unknown[] }>} props.sections - sidebar groups
 */
const BaseDashboardLayout = ({ children, brandPath, sections }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        bgcolor: 'transparent',
      }}
    >
      <AmbientBackground />
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          flex: 1,
          minHeight: '100vh',
          width: '100%',
        }}
      >
        <WelcomeOverlayRoot />
        <Header onDrawerToggle={handleDrawerToggle} />
        <Sidebar
          mobileOpen={mobileOpen}
          onDrawerToggle={handleDrawerToggle}
          brandPath={brandPath}
          sections={sections}
        />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            margin: 0,
            p: 0,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            bgcolor: 'transparent',
            transition: 'background-color 200ms ease',
          }}
        >
          <Toolbar />
          <Container
            maxWidth="lg"
            sx={{
              flexGrow: 1,
              py: { xs: 3, md: 4 },
              px: { xs: 2, sm: 3 },
              mt: 0,
              mb: 0,
            }}
          >
            {children}
          </Container>
          <Footer />
        </Box>
      </Box>
    </Box>
  );
};

export default BaseDashboardLayout;
